import { Injectable, inject } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { Observable } from 'rxjs';

export interface AccountDeletionRequestCodeInterface {
  email: string;
}

export interface AccountDeletionConfirmInterface {
  email: string;
  verification_code: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccountDeletionService {
  private readonly httpClient = inject(HttpClientService);

  requestCode(email: string): Observable<ResponseIdentity<unknown>> {
    const payload: AccountDeletionRequestCodeInterface = { email };
    return this.httpClient.post(
      API_URL_CONSTANT.accountDeletion.requestCode,
      payload
    );
  }

  confirmDeletion(
    email: string,
    verification_code: string
  ): Observable<ResponseIdentity<null>> {
    const payload: AccountDeletionConfirmInterface = {
      email,
      verification_code,
    };
    return this.httpClient.post(
      API_URL_CONSTANT.accountDeletion.confirm,
      payload
    );
  }
}
